import {IconProps} from "../icons";


export const MenuUpIcon = ({width = 24, height = 24, color}: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 15.75L12 9.75L6 15.75L18 15.75Z" fill={color}/>
    </svg>
  )
}